import { Label, Text } from '@components';
import { TItemType } from '@types';
import { formatItemTypeDimensions, formatNumber } from '@utils';
import styles from './ItemTypeLimits.module.scss';

export interface ItemTypeLimitsProps {
	itemType: TItemType;
}

/** The most one unit of an Item type can measure and weigh. */
export const ItemTypeLimits = (props: ItemTypeLimitsProps) => {
	const { itemType } = props;

	return (
		<div className={styles.limits}>
			<div>
				<Label>Max L × W × H</Label>
				<Text text={formatItemTypeDimensions(itemType)} />
			</div>
			<div>
				<Label>Max weight</Label>
				<Text text={formatNumber(itemType.max_weight_kg, { suffix: ' kg' })} />
			</div>
		</div>
	);
}
